export default {
      id: "ic-download-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/svg-sprite/sprite.3c1104713f87a2b1cb05dc7638914c5f.svg#ic-download",
      toString: function () {
        return this.url;
      }
    }